module.exports = __webpack_public_path__ + "static/media/link.019206e2.svg";